
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3_1956)","fill":"#262626"}},[_c('path',{attrs:{"d":"M7.364 7.636a3.83 3.83 0 01-3.819-3.818A3.83 3.83 0 017.364 0a3.83 3.83 0 013.818 3.818 3.83 3.83 0 01-3.818 3.818zm0-5.09c-.7 0-1.273.572-1.273 1.272 0 .7.573 1.273 1.273 1.273s1.272-.573 1.272-1.273-.572-1.273-1.272-1.273z"}}),_c('path',{attrs:{"d":"M4.818 5.09H2.273C1.573 5.09 1 4.519 1 3.819c0-.7.573-1.273 1.273-1.273h2.545c.7 0 1.273.573 1.273 1.273s-.573 1.273-1.273 1.273zM25.182 5.09H9.909c-.7 0-1.273-.572-1.273-1.272 0-.7.573-1.273 1.273-1.273h15.273c.7 0 1.273.573 1.273 1.273s-.573 1.273-1.273 1.273zM7.364 28a3.83 3.83 0 01-3.819-3.818 3.83 3.83 0 013.819-3.818 3.83 3.83 0 013.818 3.818A3.83 3.83 0 017.364 28zm0-5.09c-.7 0-1.273.572-1.273 1.272 0 .7.573 1.273 1.273 1.273s1.272-.573 1.272-1.273-.572-1.273-1.272-1.273z"}}),_c('path',{attrs:{"d":"M4.818 25.454H2.273c-.7 0-1.273-.572-1.273-1.272 0-.7.573-1.273 1.273-1.273h2.545c.7 0 1.273.573 1.273 1.273s-.573 1.273-1.273 1.273zM25.182 25.454H9.909c-.7 0-1.273-.572-1.273-1.272 0-.7.573-1.273 1.273-1.273h15.273c.7 0 1.273.573 1.273 1.273s-.573 1.273-1.273 1.273zM20.09 17.818A3.83 3.83 0 0116.274 14a3.83 3.83 0 013.818-3.818A3.83 3.83 0 0123.909 14a3.83 3.83 0 01-3.818 3.818zm0-5.09c-.7 0-1.272.572-1.272 1.272 0 .7.573 1.273 1.273 1.273S21.364 14.7 21.364 14s-.573-1.273-1.273-1.273z"}}),_c('path',{attrs:{"d":"M17.546 15.273H2.273C1.573 15.273 1 14.7 1 14s.573-1.273 1.273-1.273h15.273c.7 0 1.272.573 1.272 1.273s-.573 1.273-1.273 1.273z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3_1956"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    